import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BehaviourSubjectService {
  public isLoggedIn = new BehaviorSubject<boolean>(false);
  public RoutefromBrand: BehaviorSubject<any>;
  public isUnbxFilterChange = new BehaviorSubject<boolean>(false);
  public freeSearchTokenUpdated = new BehaviorSubject<any>(null);
  public refreshTokenSubject=new BehaviorSubject<any>(null)
  public userLoggedOut = new BehaviorSubject<any>(false);
  public userLoggedIn = new BehaviorSubject<any>(false);
  public filterValue = new BehaviorSubject<any>(false);
  public callPlp = new BehaviorSubject<any>(false);
  public loginNumber = new BehaviorSubject<any>(false);
  public splitVasPay = new BehaviorSubject<any>(false);
  public budgetFilter = new BehaviorSubject<any>(null);
  public eServiceData = new BehaviorSubject<any>(null);
  public vasCreated = new BehaviorSubject<any>(null);
  public isMobileFilter = new BehaviorSubject<any>(null);
  public dealerName = new BehaviorSubject<any>(false);
  public SearchConsoleFilterCount=new BehaviorSubject<number>(0);
  public isFilterChange = new BehaviorSubject<boolean>(false);
  private iconSubject = new BehaviorSubject<string>(null);
  public isQuotation = new BehaviorSubject<boolean>(false);
  public searchval =new BehaviorSubject<string>(null);
  public offerdetailsvisible=new BehaviorSubject<boolean>(false);
  public isSearch=new BehaviorSubject<boolean>(false);
  public isClearfilter=new BehaviorSubject<boolean>(false);
  public isSmart=new BehaviorSubject<boolean>(false);
  private submissionDataSource = new BehaviorSubject<any>(false);
  public BrandSCVsubject = new BehaviorSubject<any>(null);
  public offerDeatil = new BehaviorSubject<any>(null);
  public budgetFiltertataok = new BehaviorSubject<any>(null);
  public tataokisClearfilter=new BehaviorSubject<boolean>(false);
  private amcDataflow = new BehaviorSubject<any>(false);
  public generatetataokfilter=new BehaviorSubject<boolean>(false);
  public loyalityUserBalance = new BehaviorSubject<any>(null);

  public isTataOkLogin = new BehaviorSubject<any>(false);
  public isTataOkPLPPage = new BehaviorSubject<any>(false);

public websocketWhat = new BehaviorSubject<any>(false);

  constructor() {
    this.RoutefromBrand = new BehaviorSubject<any>(null);
    this.isLoggedIn = new BehaviorSubject<boolean>(false);
    this.isUnbxFilterChange = new BehaviorSubject<boolean>(false);
    this.freeSearchTokenUpdated = new BehaviorSubject<any>(null);
    this.refreshTokenSubject = new BehaviorSubject<any>(null);
    this.userLoggedOut = new BehaviorSubject<boolean>(false);
    this.userLoggedIn = new BehaviorSubject<boolean>(false);
    this.filterValue = new BehaviorSubject<boolean>(false);
    this.callPlp = new BehaviorSubject<boolean>(false);
    this.loginNumber = new BehaviorSubject<boolean>(false);
    this.splitVasPay = new BehaviorSubject<boolean>(false);
    this.dealerName = new BehaviorSubject<any>(false);
    this.budgetFilter = new BehaviorSubject<any>(null);
    this.eServiceData = new BehaviorSubject<any>(null);
    this.vasCreated = new BehaviorSubject<any>(null)
    this.isMobileFilter = new BehaviorSubject<any>(null)
    this.isFilterChange = new BehaviorSubject<boolean>(false);
    this.offerDeatil = new BehaviorSubject<any>(null);
    this.budgetFiltertataok = new BehaviorSubject<any>(null);
    this.loyalityUserBalance = new BehaviorSubject<any>(null);
    this.isTataOkLogin = new BehaviorSubject(false);
    this.isTataOkPLPPage = new BehaviorSubject<any>(false);
    this.websocketWhat = new BehaviorSubject<any>(false);
  }
  getAmcDataflow = this.amcDataflow.asObservable();
  iconValue$ = this.iconSubject.asObservable();
  BrandSCVsubje = this.BrandSCVsubject.asObservable();
  currentSubmissionData = this.submissionDataSource.asObservable();
  updateSubmissionData():void {
    this.submissionDataSource.next(false);
  }
  BrandSCVpic(value:any){
    this.BrandSCVsubject.next(value);
   }

}
